class CollectionCarousel extends HTMLElement {
    constructor() {
        super();
        this.flkty = null;
        this.checkViewportAndToggleFlickity = this.checkViewportAndToggleFlickity.bind(this);
        window.addEventListener('resize', this.checkViewportAndToggleFlickity);
    }

    connectedCallback() {
        this.init();
    }

    init() {
        document.addEventListener("DOMContentLoaded", this.checkViewportAndToggleFlickity);
    }

    createFlickity(carousel) {
        return new Flickity(carousel, {
            cellAlign: "center",
            wrapAround: true,
            freeScroll: false,
            pageDots: false,
            prevNextButtons: false
        });
    }

    checkViewportAndToggleFlickity() {
        const viewportWidth = window.innerWidth;
        const carousel = this.querySelector('.carousel');
        const itemsCount = parseInt(carousel.getAttribute('data-count'), 10);
        carousel.classList.remove('carousel-disabled');

        if (this.flkty) {
            this.flkty.destroy();
            this.flkty = null;
        }

        if ((itemsCount > 4) || (viewportWidth < 1251)) {
            this.flkty = this.createFlickity(carousel);
        } else if (viewportWidth >= 1251 && itemsCount <= 4) {
            carousel.classList.add('carousel-disabled');
        }
    }
}

// Define the new element
customElements.define('collection-carousel', CollectionCarousel);
